// apps/canifight/src/data/fighters.js
// All 50 fighters with combat stats (1-10) and narrative outcome stats

export const STAT_KEYS = [
  "Size & Mass",
  "Strength",
  "Speed & Agility",
  "Stamina / Endurance",
  "Offensive Weapons",
  "Defensive Capabilities",
  "Reach & Range",
  "Combat Experience / Aggression",
  "Vulnerabilities / Weak Points",
  "Environmental Adaptability",
  "Special Ability",
  "Intelligence / Tactics",
];

export const CAT_COLORS = {
  "Classic Wild Animal": "#ff3c3c",
  "Smaller But Scrappy": "#ff8c00",
  "Group of Humans": "#00cfff",
  "Single Human": "#a855f7",
  "Wildcard / Absurd": "#39ff14",
};

export const FIGHTERS = [
  // ── Classic Wild Animals ──────────────────────────────────────────
  {
    name: "Grizzly Bear", cat: "Classic Wild Animal", emoji: "🐻",
    stats: [10,10,6,8,9,9,7,8,4,7,5,4],
    tagline: "You will not win.",
    outcome: "Death", howYouWin: null, psych: "Permanently Changed",
    rematch: "Already Dead", firstBlood: "Instant", damage: "Dead", winPct: 2,
  },
  {
    name: "Lion", cat: "Classic Wild Animal", emoji: "🦁",
    stats: [9,9,8,7,9,7,7,9,5,7,5,6],
    tagline: "Apex predator. Coordinated killer.",
    outcome: "Death", howYouWin: "Lucky Shot", psych: "Permanently Changed",
    rematch: "Already Dead", firstBlood: "Seconds", damage: "Dead", winPct: 3,
  },
  {
    name: "Alligator", cat: "Classic Wild Animal", emoji: "🐊",
    stats: [8,9,5,6,9,10,6,7,4,6,4,3],
    tagline: "Death roll specialist.",
    outcome: "Death", howYouWin: "Outrun", psych: "Permanently Changed",
    rematch: "Already Dead", firstBlood: "Instant", damage: "Dead", winPct: 5,
  },
  {
    name: "Gorilla", cat: "Classic Wild Animal", emoji: "🦍",
    stats: [9,10,6,7,7,7,8,8,5,6,5,7],
    tagline: "10x human strength. Surprisingly tactical.",
    outcome: "Death", howYouWin: null, psych: "Permanently Changed",
    rematch: "Already Dead", firstBlood: "Seconds", damage: "Dead", winPct: 1,
  },
  {
    name: "Hippo", cat: "Classic Wild Animal", emoji: "🦛",
    stats: [10,10,5,6,9,10,5,9,3,5,3,3],
    tagline: "Most dangerous animal in Africa.",
    outcome: "Death", howYouWin: null, psych: "Permanently Changed",
    rematch: "Already Dead", firstBlood: "Instant", damage: "Dead", winPct: 1,
  },
  {
    name: "Bull Shark", cat: "Classic Wild Animal", emoji: "🦈",
    stats: [8,8,8,8,9,7,6,9,4,3,4,3],
    tagline: "Aggressive. Context entirely dependent.",
    outcome: "Death", howYouWin: "Outrun", psych: "Permanently Changed",
    rematch: "Already Dead", firstBlood: "Seconds", damage: "Dead", winPct: 4,
  },
  {
    name: "Saltwater Crocodile", cat: "Classic Wild Animal", emoji: "🐊",
    stats: [9,10,5,7,10,10,6,8,3,6,4,3],
    tagline: "Strongest bite force on earth.",
    outcome: "Death", howYouWin: null, psych: "Permanently Changed",
    rematch: "Already Dead", firstBlood: "Instant", damage: "Dead", winPct: 2,
  },
  {
    name: "Wolverine", cat: "Classic Wild Animal", emoji: "🦡",
    stats: [4,7,7,9,8,8,5,10,4,8,5,5],
    tagline: "Punches 10x above its weight class.",
    outcome: "KO", howYouWin: "Outlast", psych: "Traumatized",
    rematch: "Give Me a Year", firstBlood: "Seconds", damage: "Seriously Hurt", winPct: 12,
  },
  {
    name: "Cape Buffalo", cat: "Classic Wild Animal", emoji: "🐃",
    stats: [9,9,6,7,8,8,7,9,4,6,3,3],
    tagline: "Famously vengeful. Will track you.",
    outcome: "Death", howYouWin: null, psych: "Permanently Changed",
    rematch: "Already Dead", firstBlood: "Seconds", damage: "Dead", winPct: 3,
  },
  {
    name: "Komodo Dragon", cat: "Classic Wild Animal", emoji: "🦎",
    stats: [7,7,6,7,8,7,6,7,5,7,8,4],
    tagline: "Venomous. Patient stalker.",
    outcome: "Death", howYouWin: "Outrun", psych: "Traumatized",
    rematch: "Never Again", firstBlood: "Under a Minute", damage: "Barely Alive", winPct: 8,
  },

  // ── Smaller But Scrappy ───────────────────────────────────────────
  {
    name: "Badger", cat: "Smaller But Scrappy", emoji: "🦡",
    stats: [3,5,6,9,7,8,4,10,4,7,4,4],
    tagline: "Immune to snake venom. Legendary ferocity.",
    outcome: "KO", howYouWin: "Outlast", psych: "Shaken",
    rematch: "Give Me a Week", firstBlood: "Instant", damage: "Bloodied", winPct: 35,
  },
  {
    name: "Cassowary", cat: "Smaller But Scrappy", emoji: "🦤",
    stats: [6,6,7,7,8,6,7,8,5,7,5,3],
    tagline: "Razor kick can disembowel.",
    outcome: "KO", howYouWin: "Outsmart", psych: "Shaken",
    rematch: "Give Me a Week", firstBlood: "Seconds", damage: "Seriously Hurt", winPct: 25,
  },
  {
    name: "Giant Otter", cat: "Smaller But Scrappy", emoji: "🦦",
    stats: [4,5,8,8,7,5,5,8,5,8,4,5],
    tagline: "Pack hunters. Surprisingly vicious.",
    outcome: "Tap Out", howYouWin: "Outrun", psych: "Shaken",
    rematch: "Give Me a Week", firstBlood: "Seconds", damage: "Bloodied", winPct: 40,
  },
  {
    name: "Kangaroo", cat: "Smaller But Scrappy", emoji: "🦘",
    stats: [7,7,8,8,7,6,8,7,5,7,4,4],
    tagline: "Powerful kick. Can drown predators.",
    outcome: "KO", howYouWin: "Outsmart", psych: "Traumatized",
    rematch: "Give Me a Year", firstBlood: "Seconds", damage: "Seriously Hurt", winPct: 18,
  },
  {
    name: "Snapping Turtle", cat: "Smaller But Scrappy", emoji: "🐢",
    stats: [3,5,3,7,8,9,4,7,4,6,3,2],
    tagline: "Shell fortress. Beak never lets go.",
    outcome: "Tap Out", howYouWin: "Outrun", psych: "Fine",
    rematch: "Ready Immediately", firstBlood: "Under a Minute", damage: "Scratched", winPct: 55,
  },
  {
    name: "Ostrich", cat: "Smaller But Scrappy", emoji: "🐦",
    stats: [6,6,9,8,7,5,8,6,5,6,3,3],
    tagline: "Fastest land bird. Kick breaks bones.",
    outcome: "KO", howYouWin: "Outsmart", psych: "Shaken",
    rematch: "Give Me a Week", firstBlood: "Seconds", damage: "Seriously Hurt", winPct: 22,
  },
  {
    name: "Wild Boar", cat: "Smaller But Scrappy", emoji: "🐗",
    stats: [5,6,7,8,8,6,4,9,5,7,4,3],
    tagline: "Tusks. Relentless. Low center of gravity.",
    outcome: "KO", howYouWin: "Outsmart", psych: "Shaken",
    rematch: "Give Me a Week", firstBlood: "Seconds", damage: "Bloodied", winPct: 28,
  },
  {
    name: "Chimpanzee", cat: "Smaller But Scrappy", emoji: "🐒",
    stats: [5,8,8,7,7,6,7,9,5,7,5,8],
    tagline: "4x human strength. Uses tools as weapons.",
    outcome: "Death", howYouWin: "Psychological Warfare", psych: "Permanently Changed",
    rematch: "Never Again", firstBlood: "Seconds", damage: "Seriously Hurt", winPct: 10,
  },
  {
    name: "Moose", cat: "Smaller But Scrappy", emoji: "🫎",
    stats: [9,8,6,7,7,6,8,7,5,6,3,3],
    tagline: "Huge antlers. Surprisingly aggressive.",
    outcome: "KO", howYouWin: "Outrun", psych: "Traumatized",
    rematch: "Give Me a Year", firstBlood: "Under a Minute", damage: "Seriously Hurt", winPct: 15,
  },
  {
    name: "Swan", cat: "Smaller But Scrappy", emoji: "🦢",
    stats: [3,3,6,7,5,4,5,8,6,6,3,3],
    tagline: "Aggressively territorial. Will not back down.",
    outcome: "Tap Out", howYouWin: "Overpower", psych: "Shaken",
    rematch: "Ready Immediately", firstBlood: "A Few Minutes", damage: "Scratched", winPct: 65,
  },

  // ── Groups of Humans ──────────────────────────────────────────────
  {
    name: "15 Twelve-Year-Olds", cat: "Group of Humans", emoji: "👦",
    stats: [6,4,7,6,4,3,5,7,6,6,3,4],
    tagline: "Chaotic. Mob mentality. Zero chill.",
    outcome: "Tap Out", howYouWin: "Outlast", psych: "Traumatized",
    rematch: "Never Again", firstBlood: "Seconds", damage: "Bloodied", winPct: 20,
  },
  {
    name: "Line of Hippies (1 at a time)", cat: "Group of Humans", emoji: "☮️",
    stats: [5,3,4,5,2,2,4,2,7,5,2,3],
    tagline: "Low aggression. High tolerance for pain via zen.",
    outcome: "Tie", howYouWin: "Psychological Warfare", psych: "Strangely Proud",
    rematch: "Ready Immediately", firstBlood: "It Escalates Slowly", damage: "Unscathed", winPct: 80,
  },
  {
    name: "5 Sleep-Deprived Toddlers", cat: "Group of Humans", emoji: "👶",
    stats: [2,2,7,5,3,3,3,8,8,4,4,2],
    tagline: "Unpredictable. Will bite. Immune to reason.",
    outcome: "Mutual Destruction", howYouWin: "Outlast", psych: "Permanently Changed",
    rematch: "Never Again", firstBlood: "Instant", damage: "Bloodied", winPct: 45,
  },
  {
    name: "10 Angry Grandmothers", cat: "Group of Humans", emoji: "👵",
    stats: [4,3,4,6,5,4,4,8,5,5,4,6],
    tagline: "Purses as weapons. Guilt trip as tactical nuke.",
    outcome: "Tap Out", howYouWin: "Outrun", psych: "Strangely Proud",
    rematch: "Give Me a Week", firstBlood: "A Few Minutes", damage: "Scratched", winPct: 30,
  },
  {
    name: "Youth Soccer Team", cat: "Group of Humans", emoji: "⚽",
    stats: [5,4,8,7,4,3,5,6,6,6,3,4],
    tagline: "Coordinated. Cleats are weapons.",
    outcome: "KO", howYouWin: "Outsmart", psych: "Shaken",
    rematch: "Give Me a Week", firstBlood: "Seconds", damage: "Bloodied", winPct: 25,
  },
  {
    name: "3 Mildly Irritated Accountants", cat: "Group of Humans", emoji: "💼",
    stats: [5,4,4,5,3,3,4,4,6,5,2,7],
    tagline: "Strategic thinkers. Will find a loophole.",
    outcome: "Tie", howYouWin: "Outsmart", psych: "Fine",
    rematch: "Ready Immediately", firstBlood: "A Few Minutes", damage: "Scratched", winPct: 60,
  },
  {
    name: "50 Hamsters Simultaneously", cat: "Group of Humans", emoji: "🐹",
    stats: [1,1,7,8,3,2,2,6,5,5,2,1],
    tagline: "Sheer chaos. Biting from every direction.",
    outcome: "Mutual Destruction", howYouWin: "Overpower", psych: "Strangely Proud",
    rematch: "Give Me a Week", firstBlood: "Instant", damage: "Bloodied", winPct: 50,
  },
  {
    name: "Bachelorette Party (Hour 6)", cat: "Group of Humans", emoji: "👯",
    stats: [5,4,5,4,5,3,4,7,6,5,5,5],
    tagline: "Unpredictable. High heels. Emotionally volatile.",
    outcome: "Tap Out", howYouWin: "Psychological Warfare", psych: "Shaken",
    rematch: "Give Me a Week", firstBlood: "Under a Minute", damage: "Scratched", winPct: 40,
  },
  {
    name: "20 Clowns from a Tiny Car", cat: "Group of Humans", emoji: "🤡",
    stats: [5,4,6,5,4,3,4,5,6,5,6,4],
    tagline: "Confusion is their weapon.",
    outcome: "Mutual Destruction", howYouWin: "Opponent Self-Destructs", psych: "Permanently Changed",
    rematch: "Never Again", firstBlood: "Under a Minute", damage: "Bloodied", winPct: 35,
  },
  {
    name: "Hostile Flash Mob", cat: "Group of Humans", emoji: "💃",
    stats: [6,5,6,6,5,4,5,6,5,6,5,5],
    tagline: "Coordinated. Numerous. Public chaos.",
    outcome: "Escape", howYouWin: "Outrun", psych: "Traumatized",
    rematch: "Never Again", firstBlood: "Seconds", damage: "Bloodied", winPct: 30,
  },

  // ── Single Humans ─────────────────────────────────────────────────
  {
    name: "Sumo Wrestler", cat: "Single Human", emoji: "🏋️",
    stats: [10,8,3,5,6,8,5,7,5,4,3,5],
    tagline: "Immovable mass. Expert in pushing.",
    outcome: "KO", howYouWin: "Outsmart", psych: "Shaken",
    rematch: "Give Me a Year", firstBlood: "Seconds", damage: "Seriously Hurt", winPct: 15,
  },
  {
    name: "Jockey", cat: "Single Human", emoji: "🏇",
    stats: [2,3,8,7,3,2,4,5,7,6,3,6],
    tagline: "Small target. Surprisingly wiry.",
    outcome: "Tap Out", howYouWin: "Overpower", psych: "Fine",
    rematch: "Ready Immediately", firstBlood: "A Few Minutes", damage: "Scratched", winPct: 70,
  },
  {
    name: "Your Mailman", cat: "Single Human", emoji: "📬",
    stats: [5,5,6,7,4,4,5,5,6,8,3,5],
    tagline: "Walks 10 miles a day. Has seen things.",
    outcome: "Tie", howYouWin: "Outsmart", psych: "Fine",
    rematch: "Ready Immediately", firstBlood: "A Few Minutes", damage: "Scratched", winPct: 50,
  },
  {
    name: "Retired UFC Fighter", cat: "Single Human", emoji: "🥊",
    stats: [7,8,8,7,8,7,7,10,5,7,5,9],
    tagline: "Trained killer. Muscle memory never leaves.",
    outcome: "KO", howYouWin: "Lucky Shot", psych: "Traumatized",
    rematch: "Never Again", firstBlood: "Instant", damage: "Seriously Hurt", winPct: 8,
  },
  {
    name: "Very Confident 8-Year-Old", cat: "Single Human", emoji: "😤",
    stats: [2,2,7,6,3,2,4,8,7,5,4,5],
    tagline: "No fear. No concept of losing.",
    outcome: "Tap Out", howYouWin: "Overpower", psych: "Strangely Proud",
    rematch: "Ready Immediately", firstBlood: "Seconds", damage: "Scratched", winPct: 85,
  },
  {
    name: "CrossFit Person", cat: "Single Human", emoji: "💪",
    stats: [6,7,7,9,5,5,6,7,5,7,4,4],
    tagline: "Will not stop talking about it even mid-fight.",
    outcome: "KO", howYouWin: "Outlast", psych: "Shaken",
    rematch: "Give Me a Week", firstBlood: "Under a Minute", damage: "Bloodied", winPct: 35,
  },
  {
    name: "Mall Security Guard", cat: "Single Human", emoji: "🚔",
    stats: [5,5,4,5,4,4,4,5,6,6,3,5],
    tagline: "Has a walkie-talkie. Limited jurisdiction.",
    outcome: "Tie", howYouWin: "Psychological Warfare", psych: "Fine",
    rematch: "Ready Immediately", firstBlood: "It Escalates Slowly", damage: "Unscathed", winPct: 55,
  },
  {
    name: "Sleep-Deprived New Parent", cat: "Single Human", emoji: "😵",
    stats: [5,4,5,4,4,4,5,6,6,5,4,6],
    tagline: "Nothing left to lose. Primal instinct.",
    outcome: "Mutual Destruction", howYouWin: "Outlast", psych: "Strangely Proud",
    rematch: "Give Me a Week", firstBlood: "Under a Minute", damage: "Bloodied", winPct: 45,
  },
  {
    name: "Medieval Knight (Full Armor)", cat: "Single Human", emoji: "⚔️",
    stats: [7,7,4,5,7,10,6,8,3,4,3,6],
    tagline: "Nearly impenetrable. Slow but deadly.",
    outcome: "KO", howYouWin: "Outsmart", psych: "Traumatized",
    rematch: "Never Again", firstBlood: "Under a Minute", damage: "Bloodied", winPct: 20,
  },
  {
    name: "Olympic Gymnast", cat: "Single Human", emoji: "🤸",
    stats: [4,6,10,9,5,4,6,6,6,9,5,7],
    tagline: "Insane agility. Can attack from any angle.",
    outcome: "KO", howYouWin: "Overpower", psych: "Shaken",
    rematch: "Give Me a Week", firstBlood: "Seconds", damage: "Bloodied", winPct: 30,
  },

  // ── Wildcard / Absurd ─────────────────────────────────────────────
  {
    name: "Vending Machine (Took Your $)", cat: "Wildcard / Absurd", emoji: "🏧",
    stats: [8,1,1,10,2,10,1,1,5,1,3,1],
    tagline: "Immovable. Will not give back your money.",
    outcome: "Tie", howYouWin: "Opponent Self-Destructs", psych: "Strangely Proud",
    rematch: "Ready Immediately", firstBlood: "It Escalates Slowly", damage: "Unscathed", winPct: 60,
  },
  {
    name: "Your Own Shadow", cat: "Wildcard / Absurd", emoji: "👥",
    stats: [1,1,10,10,1,10,1,1,10,10,10,1],
    tagline: "Cannot be hit. Mirrors every move.",
    outcome: "Tie", howYouWin: null, psych: "Permanently Changed",
    rematch: "Never Again", firstBlood: "Instant", damage: "Unscathed", winPct: 0,
  },
  {
    name: "Roomba with a Knife", cat: "Wildcard / Absurd", emoji: "🤖",
    stats: [1,2,5,10,5,3,1,7,7,5,6,1],
    tagline: "Low to the ground. Relentless. No mercy.",
    outcome: "Tap Out", howYouWin: "Overpower", psych: "Strangely Proud",
    rematch: "Ready Immediately", firstBlood: "Under a Minute", damage: "Scratched", winPct: 75,
  },
  {
    name: "Canada Goose", cat: "Wildcard / Absurd", emoji: "🪿",
    stats: [3,3,7,8,6,4,5,10,5,7,5,2],
    tagline: "Zero fear. Infinite aggression. Will not stop.",
    outcome: "Mutual Destruction", howYouWin: "Outlast", psych: "Traumatized",
    rematch: "Never Again", firstBlood: "Instant", damage: "Bloodied", winPct: 40,
  },
  {
    name: "IKEA Furniture Assembly", cat: "Wildcard / Absurd", emoji: "🔧",
    stats: [6,1,1,10,5,5,1,10,2,5,8,1],
    tagline: "Psychological warfare. Instructions make no sense.",
    outcome: "Mutual Destruction", howYouWin: "Outlast", psych: "Permanently Changed",
    rematch: "Never Again", firstBlood: "A Few Minutes", damage: "Scratched", winPct: 30,
  },
  {
    name: "1,000 Duck-Sized Horses", cat: "Wildcard / Absurd", emoji: "🐴",
    stats: [1,2,8,9,3,3,3,7,4,7,5,2],
    tagline: "Overwhelming numbers. Tiny hooves everywhere.",
    outcome: "Mutual Destruction", howYouWin: "Overpower", psych: "Strangely Proud",
    rematch: "Give Me a Week", firstBlood: "Seconds", damage: "Bloodied", winPct: 45,
  },
  {
    name: "1 Horse-Sized Duck", cat: "Wildcard / Absurd", emoji: "🦆",
    stats: [9,8,6,7,7,6,7,8,5,6,5,3],
    tagline: "Bill like a battering ram. Honk is deafening.",
    outcome: "KO", howYouWin: "Outsmart", psych: "Traumatized",
    rematch: "Never Again", firstBlood: "Seconds", damage: "Seriously Hurt", winPct: 15,
  },
  {
    name: "Raccoons (Garbage Pizza)", cat: "Wildcard / Absurd", emoji: "🦝",
    stats: [2,3,8,8,5,4,4,9,5,8,6,5],
    tagline: "Feral intelligence. Opposable thumbs. No rules.",
    outcome: "Mutual Destruction", howYouWin: "Dirty Move", psych: "Shaken",
    rematch: "Give Me a Week", firstBlood: "Instant", damage: "Bloodied", winPct: 40,
  },
  {
    name: "Sentient Shopping Cart", cat: "Wildcard / Absurd", emoji: "🛒",
    stats: [4,2,5,10,4,5,4,8,6,5,5,2],
    tagline: "Wheel goes sideways at the worst moment.",
    outcome: "Tie", howYouWin: "Opponent Self-Destructs", psych: "Fine",
    rematch: "Ready Immediately", firstBlood: "A Few Minutes", damage: "Unscathed", winPct: 65,
  },
  {
    name: "Pigeons Who've Done This Before", cat: "Wildcard / Absurd", emoji: "🐦",
    stats: [1,2,7,9,4,3,4,8,5,8,6,4],
    tagline: "Dead eyes. Battle-hardened. They know.",
    outcome: "Escape", howYouWin: "Outrun", psych: "Shaken",
    rematch: "Give Me a Week", firstBlood: "Seconds", damage: "Scratched", winPct: 50,
  },
];

// Default average human stats (used when survey is skipped)
export const DEFAULT_USER_STATS = Array(12).fill(5);
